import axios from "axios";

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API,
  // baseURL: `http://192.168.0.150:8888`
});
export const instance3di = axios.create({
  baseURL: process.env.REACT_APP_3DI_API,
  // baseURL: `http://192.168.0.150:8888`
});

console.log("3DI API:", process.env.REACT_APP_3DI_API);

export const checkLocalStorage = () => {
  if (localStorage.getItem("_session")) {
    return localStorage.getItem("_session");
  } else {
    return "csse79Mjk3OA==";
  }
};

export const getSessionHeaders = () => {
  const session = checkLocalStorage();

  return {
    session_id: session,
  };
};

const fetchActiveEvents = function (params) {
  const req = instance3di.get(`/v1/events/${getSessionHeaders()?.session_id}`, {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

const fetchPredictHistory = function (params) {
  const req = instance.get("v1/statistics-match", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

const fetchPredictDetail = function (params) {
  const req = instance.get("v1/predicts", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

const fetchPredictList = function (params) {
  const req = instance.get("v1/predicts", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

const createPredict = function (payload) {
  const req = instance.post("v1/predicts", payload, {
    headers: getSessionHeaders(),
  });
  return req;
};

const getPredictInfo = function (id) {
  const req = instance.get("v1/predicts/" + id, {
    headers: getSessionHeaders(),
  });
  return req;
};

const getMatchesInfo = function (id) {
  const req = instance.get("v1/matches/" + id, {
    headers: getSessionHeaders(),
  });
  return req;
};
const getMatches = function (params) {
  const req = instance.get("v1/matches", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};
const getMatchesGuest = function () {
  const req = instance.get("v1/matches-current-guess", {
    headers: getSessionHeaders(),
  });
  return req;
};

const getAllTeams = function (params) {
  const req = instance.get("v1/teams", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

const getRounds = function () {
  const req = instance.get("v1/rounds", {
    headers: getSessionHeaders(),
  });
  return req;
};

const createPredictChampion = function (payload) {
  const req = instance.post("v1/predicts-champion", payload, {
    headers: getSessionHeaders(),
  });
  return req;
};

const getMatchesPredicts = function (params) {
  const req = instance.get("v1/matches-predicts", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

const getPredictChampion = function (params) {
  const req = instance.get("v1/predicts-champion", {
    params,
    headers: getSessionHeaders(),
  });
  return req;
};

export function getTimeServer() {
  const req = instance.get("v1/time-server", {
    headers: getSessionHeaders(),
  });
  return req;
}

const predictsChampionEndAt = () => {
  const req = instance.get("v1/predicts-champion-end-at", {
    headers: getSessionHeaders(),
  });
  return req;
};

const predictAPI = {
  fetchPredictHistory,
  fetchPredictDetail,
  fetchPredictList,
  createPredict,
  getPredictInfo,
  instance,
  checkLocalStorage,
  getSessionHeaders,
  getMatchesInfo,
  getMatches,
  getMatchesGuest,
  getAllTeams,
  getRounds,
  createPredictChampion,
  getMatchesPredicts,
  getPredictChampion,
  predictsChampionEndAt,
  fetchActiveEvents,
};
export default predictAPI;
